import { useScrollProgress } from "@/hooks/useScrollProgress";

const ScrollProgressBar = () => {
  const progress = useScrollProgress();

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] h-[3px] bg-transparent">
      <div
        className="h-full bg-gradient-to-r from-primary to-accent transition-none"
        style={{ width: `${progress * 100}%` }}
      />
    </div>
  );
};

export default ScrollProgressBar;
